import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { TextField } from '@mui/material';

export default function ReactDatePicker({ field, form, ...props }) {
  return (
    <div>
      <style>
        {`
          .react-datepicker__navigation {
          display: none !important;}
          .react-datepicker__current-month {
          display: none !important;
          }`}
      </style>

      <DatePicker
        id={field.name}
        {...props}
        selected={field.value ? new Date(field.value) : null}
        onChange={(val) => {
          if (val instanceof Date && !isNaN(val)) {
            // Fix timezone offset issue by subtracting the timezone offset in ms
            const correctedDate = new Date(
              val.getTime() - val.getTimezoneOffset() * 60000,
            );
            form.setFieldValue(
              field.name,
              correctedDate.toISOString().split('T')[0],
            );
          } else {
            form.setFieldValue(field.name, ''); //nnull value should ignore
          }
        }}
        onCalendarClose={() =>
          setTimeout(() => {
            form.setFieldTouched(field.name, true, true);
          }, 0)
        }
        placeholderText='DD-MM-YYYY'
        dateFormat='dd/MM/yyyy'
        isClearable
        showMonthDropdown
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={51}
        dropdownMode='scroll'
        minDate={new Date(1980, 0, 1)}
        maxDate={new Date(2050, 11, 31)}
        wrapperClassName='w-full'
        autoComplete='off'
        customInput={
          <TextField
            fullWidth
            size='small'
            sx={{
              // Default green border
              '& .MuiOutlinedInput-notchedOutline': {
                border: '1px solid oklch(93% 0.034 272.788)',
              },
              // Remove blue focus outline and keep green border on focus
              '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
                {
                  borderColor: 'black',
                  boxShadow: 'none', // Remove glow or shadow
                },
              // Remove default browser outline focus ring
              '& .MuiOutlinedInput-root.Mui-focused': {
                outline: 'none',
              },
              // Remove blue border on hover when focused
              '& .MuiOutlinedInput-root:hover.Mui-focused .MuiOutlinedInput-notchedOutline':
                {
                  borderColor: 'black',
                  boxShadow: 'none',
                },
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: 'oklch(93% 0.034 272.788)', // removes border highlight on hover
                },
              },
            }}
          />
        }
      />
    </div>
  );
}
